import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import { defineStore } from 'pinia'
import AccountAPI from '../constants/account.api.uri.const'

export enum AccountBOActionType {
  FETCHING = 'fetching',
  FETCHED = 'fetched',
  FETCH_FAILED = 'fetch_failed',
  CREATING = 'creating',
  CREATED = 'created',
  CREATE_FAILED = 'create_failed',
  UPDATING = 'updating',
}

interface AccountBO {
  id: number
  code: string
  fullname: string
  phone: string
  email: string
  status: string
  profile_pic: string | null
  created_at: string
  updated_at: string
  role: object
  perms: string[]
}

interface AccountBOState {
  accounts: {
    [key: string]: {
      action_type: AccountBOActionType
      action_message: string
      account: AccountBO
    }
  }
}

export const useAccountBODetailStore = defineStore('account.bo.detail', {
  state: (): AccountBOState => ({
    accounts: {},
  }),
  getters: {},
  actions: {
    async fetchAccountBO(id: number) {
      return new Promise(async (resolve, reject) => {
        try {
          this.accounts[id] = {
            ...this.accounts[id],
            action_type: AccountBOActionType.FETCHING,
          }
          const res: any = await APIClient.get(AccountAPI.bo.detail.replace(':id', id.toString()))
          const { data } = res.data

          this.accounts[id] = {
            action_type: AccountBOActionType.FETCHED,
            action_message: res?.data?.message,
            account: {
              ...data,
              permissions_original: data?.permissions,
            },
          }
          resolve(data)
        } catch (e) {
          console.log(e);

        }
      })
    },
    async setAccount(id: number, account: Object) {
      this.accounts[id] = {
        action_type: AccountBOActionType.FETCHED,
        action_message: '',
        account: { ...this.accounts[id].account, ...account },
      }
    },
  },
})
